module.exports = {
  siteTitle: 'Uptime Formation - Formations DevOps', // <title>
  siteDescription:
    "Formations DevOps - Prendre le temps d'apprendre, démystifier le cloud et l'informatique moderne par l'expérimentation, loin des buzzwords.", // <meta>
  manifestName: 'uptime',
  manifestShortName: 'uptime', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/favicon.png',
  // pathPrefix: `/uptime/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Uptime Formation',
  // subHeading: "Prendre le temps d'apprendre\n\nDémystifier l'informatique moderne\n\nL'expérimentation, loin des buzzwords",
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      username: 'uptime-formation',
      url: 'https://github.com/uptime-formation',
    },
    {
      icon: 'fa-gitlab',
      name: 'Framagit',
      username: 'uptime',
      url: 'https://framagit.org/uptime',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      username: 'uptimeformation',
      url: 'https://twitter.com/uptimeformation',
    },
    {
      icon: 'fa-linkedin',
      name: 'LinkedIn',
      username: 'uptime-formation',
      url: 'https://www.linkedin.com/company/uptime-formation',
    },
  //   {
  //     icon: 'fa-facebook',
  //     name: 'Facebook',
  //     url: 'https://facebook.com/theanubhav',
  //   },
  ],
  emailId: 'uptime@uptime-formation.fr',
  phone: '+33 7 49 42 73 71',
  address: '3/7 rue Albert Marquet - 75020 Paris, France',
  legal: 'Uptime Formation fait partie de Coopaname SCOP-SA à capital variable - RCS Paris B 448 762 526 - Siret : 448 762 526 00136',
  formation: 'Coopaname est déclaré comme organisme de formation sous le n° 11 75 38725 75 - Référençable Datadock n°00008176',
};
